module.exports = __webpack_public_path__ + "static/media/lp_certification.1b246621.svg";